import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { isAppWarmup } from '../../utils/appWarmup'

/**
 * RESH13-1145: a prefetched document never loads GTM/gtag, so a client-side
 * navigation inside it would lose that page's view. Turn the first real
 * navigation into a full load instead — the target URL has no `c13Warmup`,
 * so it loads with analytics and auto-refresh as usual.
 */
export function useAppWarmupNavigation() {
  const router = useRouter()

  useEffect(() => {
    if (!isAppWarmup()) {
      return
    }
    const onRouteChangeStart = (
      url: string,
      { shallow }: { shallow: boolean }
    ) => {
      // Shallow pushes are URL updates by code (e.g. playlist auto-advance),
      // not the user opening a page
      if (shallow) {
        return
      }
      window.location.assign(url.replace('[[...all]]', ''))
    }
    router.events.on('routeChangeStart', onRouteChangeStart)
    return () => {
      router.events.off('routeChangeStart', onRouteChangeStart)
    }
  }, [router.events])
}
